import styled from "styled-components";

export const Form = styled.form`
    display: flex;
    justify-content:space-between;
    flex-direction: column;
    gap: 20px;
`